/* Progressive enhancement: content is visible before JavaScript and on errors. */
(() => {
  if (window.trufaEvolutionInitialized) return;
  window.trufaEvolutionInitialized = true;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const init = (scope = document) => {
    const roots = [...scope.querySelectorAll('[data-trufa-modular]')];
    if (scope.matches?.('[data-trufa-modular]')) roots.push(scope);
    roots.forEach(root => {
      if (root.dataset.ready) return;
      const controls = root.querySelector('[data-modular-controls]');
      if (!controls) return;
      root.dataset.ready = 'true';
      controls.hidden = false;
      controls.addEventListener('click', event => {
        const button = event.target.closest('[data-modular-view]');
        if (!button) return;
        root.dataset.view = button.dataset.modularView;
        controls.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      });
    });
    if (!motion.matches && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.animate?.([{transform:'translateY(12px)'},{transform:'translateY(0)'}], {duration:500,easing:'cubic-bezier(.22,1,.36,1)'});
          observer.unobserve(entry.target);
        });
      }, {threshold:0.12});
      scope.querySelectorAll('.trufa-reveal, .trufa-process-grid article').forEach(item => observer.observe(item));
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
